import React from 'react';
import './index.sass';

export default () => {
    return (
        <div className="more-menu-icon">
            <div></div>
        </div>
    );
};